


















import Vue from 'vue'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import ImageUpload from "@/components/products/railway/CustomRailwayImageUpload.vue"
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'
import SingleAssetUpload from '@/components/products/railway/util/RailwaySingleAssetUpload'
import { ImageClipper } from '@/utils/imageClipper'
import { AssetUsage } from '@/utils/assetUsage'
import { AssetsModule } from '@/store/modules/asset'
import { RailwayModule } from '@/store/modules/railway'
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
    
@Component({
    name: 'railway-image-upload',
    components: { PrimaryButtons, ImageUpload }
})
export default class DesignTitleUpload extends Mixins(SingleAssetUpload) {
    doConfirm(asset?: AssetFile, imageClipper?: ImageClipper, usage?: SingleAssetUsage): boolean {
        if (AssetsModule.selected && asset && asset.assetId && usage && imageClipper) {
            RailwayModule.SetRailwayImageBoundingBox(imageClipper.boundingBox)
            RailwayModule.SetRailwayImageRotation(usage.rotation)
            RailwayModule.SetRailwayImageAssetId(asset.assetId)
            return true
        } else {
            if (!asset || !AssetsModule.selected) {
                AssetUsage.deleteAllUsage()
                RailwayModule.SetRailwayImageAssetId(-1)
                return true
            } else {
                return false
            }
        }
    }

    onUploadCancel() {
        if (!AssetsModule.selected && RailwayModule.railwayAssetId !== -1) {
            let asset = AssetUsage.getCommitedAsset()
            if (!asset) {
                RailwayModule.SetRailwayImageAssetId(-1)
            }
        }
        this.onCancel()
    }

    get confirmable(): boolean {
        return !ToolbarModule.error
    }

    useDefaultImage() {
        this.asset = undefined
        let selectedAsset = AssetsModule.selected
        if (selectedAsset) {
            AssetUsage.captureUsage(selectedAsset)
            AssetsModule.Select()
        }
        AssetsModule.Select(undefined)
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
    }
}
